export default function ParseKeypointsToJSON(htmlString) {
    const parser = new DOMParser()
    const document = parser.parseFromString(htmlString, "text/html")
    const items = document.querySelectorAll("li")
    const jsonResult = Array.from(items).map(li => li.textContent.trim())
    return {verbatims: jsonResult}
}